import { AnimatedOutlet } from '@/components/motion/AnimatedOutlet';
import { AppFooter } from '@/components/AppFooter';
import { AppHeader } from '@/components/AppHeader';
import { OfflineBanner } from '@/components/OfflineBanner';
import { VenueSwitchBridge } from '@/components/VenueSwitchBridge';

export default function App() {
  return (
    <div className="flex min-h-svh flex-col">
      <OfflineBanner />
      <AppHeader />
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-8 sm:px-5">
        <AnimatedOutlet />
      </main>
      <AppFooter />
      <VenueSwitchBridge />
    </div>
  );
}
